import { all, put } from 'redux-saga/effects';

import { calculateDefaultRowValues } from '../../helpers/rows';
import { sendError } from '../../helpers/errorReport';

import * as AutofillActions from '../Autofill/actions';
import {
  selectClientsData,
  selectCompanyData,
  selectDepartmentOptions,
  selectItemsData,
  selectLocationOptions,
  selectProjectsPerClientId,
  selectTasksPerProjectId,
  selectUserData,
} from '../selectors';

function* HandleAutofillValues({ autofillValues, from, rowId }) {
  yield all(autofillValues.map((a) => put(AutofillActions.setAutofill({ rowId, a, from }))));
}

function* GenerateRowAutofill({ row, store }) {
  try {
    const companyData = selectCompanyData(store);
    const projectId = !!companyData?.showProject ? row.entries?.length && row.entries[0]?.confirmedProjectId : 'all';
    const tasksData = selectTasksPerProjectId(store, projectId);
    const departmentOptions = selectDepartmentOptions(store);
    const locationOptions = selectLocationOptions(store);
    const userData = selectUserData(store);
    const { pClientId, pDepartment, pDepartmentObj, pItemId, pLocation, pLocationObj, pProjectId, pTaskId, taskObj } =
      calculateDefaultRowValues({ row, companyData, tasksData, departmentOptions, locationOptions });
    if (userData?.autofillValues?.length > 0) {
      yield HandleAutofillValues({ autofillValues: userData.autofillValues, rowId: row.id, from: 'user' });
    }
    if (pClientId) {
      const clientsData = selectClientsData(store);
      const clientObj = clientsData.find((c) => c.id === pClientId) || row?.dimensionValues?.client;
      if (clientObj?.autofillValues?.length > 0) {
        yield HandleAutofillValues({ autofillValues: clientObj.autofillValues, rowId: row.id, from: pClientId });
      }
    }
    if (pProjectId) {
      const projectsData = selectProjectsPerClientId(store, pClientId || 'all');
      const projectObj = projectsData.find((c) => c.id === pProjectId) || row?.dimensionValues?.project;
      if (projectObj?.autofillValues?.length > 0) {
        yield HandleAutofillValues({ autofillValues: projectObj.autofillValues, rowId: row.id, from: pProjectId });
      }
    }
    const taskAutofillValues =
      (taskObj?.autofillValues?.length > 0 && taskObj?.autofillValues) || row?.dimensionValues?.task?.autofillValues;
    if (pTaskId && taskAutofillValues?.length > 0) {
      yield HandleAutofillValues({ autofillValues: taskAutofillValues, rowId: row.id, from: pTaskId });
    }
    if (pItemId) {
      const itemsData = selectItemsData(store);
      const itemObj = itemsData.find((c) => c.id === pItemId);
      if (itemObj?.autofillValues?.length > 0) {
        yield HandleAutofillValues({ autofillValues: itemObj.autofillValues, rowId: row.id, from: pItemId });
      }
    }
    if (pDepartmentObj && pDepartment && pDepartmentObj.autofillValues?.length > 0) {
      yield HandleAutofillValues({ autofillValues: pDepartmentObj.autofillValues, rowId: row.id, from: pDepartment });
    }
    if (pLocationObj && pLocation && pLocationObj.autofillValues?.length > 0) {
      yield HandleAutofillValues({ autofillValues: pLocationObj.autofillValues, rowId: row.id, from: pLocation });
    }
  } catch (err) {
    sendError(err, {
      type: 'AUTOFILL_ERROR',
      payload: {
        row,
        store,
      },
    });
  }
}

export { GenerateRowAutofill, HandleAutofillValues };
